import { render, staticRenderFns } from "./VInputPhone.vue?vue&type=template&id=064fb646&"
import script from "./VInputPhone.vue?vue&type=script&lang=js&"
export * from "./VInputPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports